import { render, staticRenderFns } from "./ProjectRealEstateManualEntry.vue?vue&type=template&id=ebaaaed8"
import script from "./ProjectRealEstateManualEntry.vue?vue&type=script&lang=ts"
export * from "./ProjectRealEstateManualEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports